/** @jsx h */
import { h, Fragment } from 'preact'
import { SlideContent } from './Slide'

const VideoSlideContent = ({ videoUrl, description, proofPoints, title, populateDrawer }) => {
  const disableContextMenu = e => (
    e.preventDefault()
  )

  return (
    <Fragment>
      <video
        className='Journey-backgroundVideo--video'
        onContextMenu={disableContextMenu}
        autoPlay
        disablePictureInPicture
        disableRemotePlayback
        muted
        loop
        playsInline
      >
        <source
          src={videoUrl}
          type='video/mp4'
        />
      </video>
      <div className='Journey-content Journey-content--video noselect'>
        {/* Intentionally empty - we put the other elements on top of this one */}
      </div>
      <div className='Journey-backgroundVideo--content noselect'>
        <SlideContent
          description={description} proofPoints={proofPoints} title={title}
          populateDrawer={populateDrawer}
        />
      </div>
    </Fragment>
  )
}

export default VideoSlideContent
